import InvoiceOrders from './InvoiceOrders';

export default InvoiceOrders;
